import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

const LikeButton = () => {
 const [liked, setLiked] = useState(false);

 const handleClick = () => {
    setLiked(!liked);
 };

 return (
    <IconButton onClick={handleClick}>
      {liked ? <FavoriteIcon color="error" /> : <FavoriteBorderIcon />}
    </IconButton>
 );
};

export default LikeButton;